import { IntermediaryUserCreationModule, PageHeader } from '@korint/folio';

export const IntermediaryUserCreationForm = () => {
  return (
    <div>
      <PageHeader title="Utilisateurs" />
      <IntermediaryUserCreationModule />
    </div>
  );
};
